import { useState } from "react";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { cn } from "~/lib/utils";
import { useOnMount } from "@hooks/useOnMount";

interface Props {
  containerClassName?: string;
  className?: string;
  children: React.ReactNode;
}

export default function Page({
  containerClassName,
  className,
  children,
}: Props) {
  const [isMounted, setIsMounted] = useState(false);

  useOnMount(() => {
    setIsMounted(true);
  });

  const [animationParent] = useAutoAnimate((el) => {
    const keyframes = [{ opacity: 0 }, { opacity: 1 }];
    return new KeyframeEffect(el, keyframes, {
      duration: 300,
      easing: "ease-out",
    });
  });

  return (
    <div
      ref={animationParent}
      className={cn(
        "flex flex-col items-center justify-start mb-12 flex-1",
        className,
      )}
    >
      {isMounted && (
        <div
          className={cn(
            "flex flex-col w-full max-w-appWidth gap-6 pt-6 px-6",
            containerClassName,
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
}
